import { render } from "./InfoVerduurzaming.vue?vue&type=template&id=2662524d&scoped=true"
import script from "./InfoVerduurzaming.vue?vue&type=script&lang=js"
export * from "./InfoVerduurzaming.vue?vue&type=script&lang=js"

import "./InfoVerduurzaming.vue?vue&type=style&index=0&id=2662524d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2662524d"]])

export default __exports__